var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { UitkButtonSize, UitkSecondaryButton } from 'uitk-react-button';
import { UitkLink } from 'uitk-react-link';
import { ClickTracker } from 'bernie-analytics';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';
import { bannerUtils } from './banner-utils';
var UitkLinkTracked = ClickTracker(UitkLink);
var UitkSecondaryButtonTracked = ClickTracker(UitkSecondaryButton);
var GDPRBannerExplictOptIn = /** @class */ (function (_super) {
    __extends(GDPRBannerExplictOptIn, _super);
    function GDPRBannerExplictOptIn(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { display: true };
        _this.onOptIn = _this.onOptIn.bind(_this);
        return _this;
    }
    GDPRBannerExplictOptIn.prototype.onOptIn = function () {
        var logger = this.props.logger;
        this.setState({ display: false });
        bannerUtils.setOptInWithReload(logger);
    };
    GDPRBannerExplictOptIn.prototype.render = function () {
        var globalComponentsContext = this.props.globalComponentsContext;
        var display = this.state.display;
        if (!display) {
            return null;
        }
        var bannerType = globalComponentsContext && globalComponentsContext.header.banner.type;
        if (bannerType !== 'gdpr') {
            return null;
        }
        var _a = globalComponentsContext.header.banner.info, linkText = _a.linkText, linkURL = _a.linkURL, message = _a.message, primaryActionText = _a.primaryActionText;
        return (React.createElement("div", { className: "gdpr-banner-explicit" },
            React.createElement(UitkSpacing, { padding: { inline: 'four', block: 'four' } },
                React.createElement("section", { className: "gdpr-banner-explicit__content" },
                    React.createElement("div", { className: "gdpr-banner-explicit__content__text-area" },
                        React.createElement(UitkText, { size: 400 },
                            React.createElement("p", null,
                                message,
                                ' ',
                                linkURL && linkText && (React.createElement(UitkLinkTracked, { theme: "inverse", inline: true, rfrr: "GDPR.BANNER.PWA.MOREINFO", linkName: "GDPR Learn More", trackImmediate: true },
                                    React.createElement("a", { href: linkURL }, linkText)))))),
                    React.createElement(UitkSpacing, { padding: {
                            small: { blockstart: 'three' }, medium: { inlinestart: 'twelve' }, large: { inlinestart: 'twelve' }, extra_large: { inlinestart: 'twelve' }
                        } },
                        React.createElement("div", { className: "gdpr-banner-explicit__content__button-area" },
                            React.createElement(UitkSecondaryButtonTracked, { type: "button", tabIndex: 0, onClick: this.onOptIn, size: UitkButtonSize.SMALL, rfrr: "GDPR.BANNER.PWA.ACCEPT", linkName: "GDPR Accept", trackImmediate: true }, primaryActionText)))))));
    };
    return GDPRBannerExplictOptIn;
}(React.Component));
export { GDPRBannerExplictOptIn };
//# sourceMappingURL=gdpr-banner-explicit-opt-in.js.map